import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { useSelector, useDispatch } from 'react-redux'
import history from 'src/history'

// Components
import { Text, Button } from 'src/Components'

// Selectors
import { selectHomeAddressStateName } from 'src/store/selectors/home'
import { hasCustomerToken } from 'src/auth'

// Actions
import { handleAcknowledgeTuneValue } from 'src/actions/homeowner'

// Utils
import { dispatchEvent } from 'src/helpers/tagManager'
import {
  NonDisclosureLooksGoodClicked,
  NonDisclosureToolTipLoad,
  NonDisclosureLearnMoreClicked,
} from 'src/constants/trackingEvents'
import { OVERLAY_HELPERS } from 'src/constants/navigation'

// Styles
import styles from '../Chart.module.scss'
import ndStyles from './NonDisclosureToolTipWarning.module.scss'

const propTypes = { setForceHide: PropTypes.func }

const NonDisclosureToolTipWarning = ({ setForceHide }) => {
  const dispatch = useDispatch()
  const stateName = useSelector(selectHomeAddressStateName)

  const handleLooksGood = () => {
    setForceHide(true)
    if (hasCustomerToken()) return

    dispatchEvent(NonDisclosureLooksGoodClicked)
    dispatch(handleAcknowledgeTuneValue())
  }

  const handleLearnMore = () => {
    history.push(OVERLAY_HELPERS.nonDisclosureWarning.buildPath())
  }

  useEffect(() => {
    dispatchEvent(NonDisclosureToolTipLoad)
  }, [])

  return (
    <>
      <Text
        weight='semibold'
        upperspaced
        className={styles.title}
        variant='neutralCool'
        variantCount='900'
      >
        <FormattedMessage
          id='Homeowner.estimatedValue.nonDisclosureStateWarning'
          defaultMessage='{stateName} limits public data'
          values={{ stateName }}
        />
      </Text>
      <Text
        size='xs'
        variant='neutralCool'
        variantCount='700'
        className={styles.describe}
      >
        <FormattedMessage
          id='Homeowner.estimatedValue.nonDisclosureStateWarningSubTitle'
          defaultMessage='This means the estimated value could be less accurate'
        />
      </Text>
      <div className={ndStyles.buttonWrapper}>
        <Button
          data-qa='non-disclosure-learn-more-btn'
          onClick={handleLearnMore}
          track={NonDisclosureLearnMoreClicked}
          fullWidth
          className={styles.button}
        >
          <FormattedMessage
            id='AVM.chart.tooltip.nonDisclosure.tooltip.button'
            defaultMessage='Learn more'
          />
        </Button>
        <div className={ndStyles.divider} />
        <Button
          data-qa='non-disclosure-looks-good-btn'
          onClick={handleLooksGood}
          fullWidth
          className={styles.button}
        >
          <FormattedMessage
            id='AVM.chart.tooltip.nonDisclosure.tooltip.acknowledgeButton'
            defaultMessage='Looks good'
          />
        </Button>
      </div>
    </>
  )
}

NonDisclosureToolTipWarning.propTypes = propTypes
export default NonDisclosureToolTipWarning
